export const MAX_SECONDARY_ADDRESSES = 5;
